/**
 * Toast Notification System
 * Lightweight toast notifications and confirmation dialogs
 */

export const Toast = {
  show: (message, type = 'info', duration = 3000) => {
    const toast = document.createElement('div');
    toast.className = `fixed top-4 right-4 z-50 px-4 py-3 rounded-lg shadow-lg text-white font-medium transform transition-all duration-300 translate-x-full ${
      type === 'success' ? 'bg-green-500' : 
      type === 'error' ? 'bg-red-500' : 
      type === 'warning' ? 'bg-yellow-500' : 
      'bg-blue-500'
    }`;
    toast.textContent = message;
    
    document.body.appendChild(toast);
    
    // Slide in
    setTimeout(() => toast.classList.remove('translate-x-full'), 10);
    
    // Auto remove
    setTimeout(() => {
      toast.classList.add('translate-x-full');
      setTimeout(() => document.body.removeChild(toast), 300);
    }, duration);
  },

  confirm: (message, onConfirm, onCancel = null) => {
    const overlay = document.createElement('div');
    overlay.className = 'fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center';
    
    overlay.innerHTML = `
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 max-w-sm mx-4">
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Confirm Action</h3>
          <p class="text-gray-600 dark:text-gray-300">${message}</p>
        </div>
        <div class="flex justify-end gap-3">
          <button id="cancelBtn" class="px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded">Cancel</button>
          <button id="confirmBtn" class="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded">Confirm</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(overlay);
    
    const confirmBtn = overlay.querySelector('#confirmBtn');
    const cancelBtn = overlay.querySelector('#cancelBtn');
    
    const cleanup = () => document.body.removeChild(overlay);
    
    confirmBtn.onclick = () => {
      cleanup();
      onConfirm();
    };
    
    cancelBtn.onclick = () => {
      cleanup();
      if (onCancel) onCancel();
    };
    
    overlay.onclick = (e) => {
      if (e.target === overlay) {
        cleanup();
        if (onCancel) onCancel();
      }
    };
  }
};
